export default {
  methods: {
    pointsToRandValue(points) {
      return Math.floor(Math.abs(points / 10));
    },
  }
};